import React from "react";
import { createHashRouter, RouterProvider } from "react-router-dom";
import Home from "../pages/home/HomeComponent";
import Education from "../pages/education/EducationComponent";
import Experience from "../pages/experience/Experience";
import Contact from "../pages/contact/ContactComponent";
import Projects from "../pages/projects/Projects";
import Error404 from "../pages/errors/error404/Error";

export default function Main(props) {
  const router = createHashRouter([
    {
      path: "/",
      element: <Home theme={props.theme} />
    },
    {
      path: "/home",
      element: <Home theme={props.theme} />
    },
    {
      path: "/career",
      element: <Experience theme={props.theme} />
    },
    {
      path: "/education",
      element: <Education theme={props.theme} />
    },
    {
      path: "/contact",
      element: <Contact theme={props.theme} />
    },
    {
      path: "/projects",
      element: <Projects theme={props.theme} />
    },
    {
      path: "*",
      element: <Error404 theme={props.theme} />
    }
  ]);

  return (
    <div>
      <RouterProvider router={router} />
    </div>
  );
}
